import { collectionProductFragment } from './get-collection-products-query'
import { metafieldFragment } from './utils'

// eslint-disable-next-line import/prefer-default-export
export const getCollectionProductsOnlyQuery = /* GraphQL */ `
	query getCollectionProducts(
		$collectionHandle: String
		$first: Int = 20
	) {
		collection(handle: $collectionHandle) {
			id
			title
			handle
			products(
				first: $first
			) {
				edges {
					node {
						...collectionProduct
					}
				}
			}
		}
	}

	${collectionProductFragment}
	${metafieldFragment}
`
